// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tep-pv-item-wrap[data-v-ddb69a32] {\r\n    display: flex;\r\n    flex: 1;\n}\n.tep-pv-item-wrap[data-v-ddb69a32] .dx-field {\r\n    margin-right: 5px;\n}\n.tep-pv-label[data-v-ddb69a32] {\r\n    color: rgba(117,117,117,.87);\r\n    font-size: 13px;\r\n    cursor: default;\r\n    display: flex;\r\n    align-items: center;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
